import { FlexibleTemplateAdapter as FlexibleTemplate } from "./FlexibleTemplate";

export { FlexibleTemplate };
export type { FlexibleTemplateProps, FlexibleTemplateContent } from "./FlexibleTemplate.d";
